export const onTapTileLayout = {
  1: 'Default',
  2: 'Report Only',
  3: 'Full Inventory',
  4: 'Net Volume',
  Default: 1,
  'Report Only': 2,
  'Full Inventory': 3,
  'Net Volume': 4,
};
